import { Chip, Grid, IconButton, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";
import MainCard from "../../../components/Maincard";
import SearchTextFieldComp from "../../newComponent/newtextfieldComp/SearchTextFieldComp";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import AddButton from "../../newComponent/NewButtonComp/AddButton";
import CustomPopup from "../../../components/CustomPopup";
import AddRealTestProduct from "./AddRealTestProduct";
import { useGetTokenOrLogout } from "../../../utils/token";
import LoaderComp from "../../newComponent/LoaderComp/Loader";
import ConfirmationPopup from "../../../components/ConfirmationPopup";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import { Edit } from "@mui/icons-material";
import EditRealTestProduct from "./EditRealTestProduct";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function RealTestProduct() {
  const [isLoading, setIsLoading] = useState(false);
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const [products, setProducts] = useState([]);
  const [isAddFormOpen, setIsAddFormOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isDeleteFormOpen, setIsDeleteFormOpen] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [searchData, setSearchData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [openEditForm, setOpenEditForm] = useState(false);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleOpenForm = () => {
    setIsAddFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsAddFormOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      const token = getTokenOrLogout();
      if (!token) return;

      try {
        const headers = {
          Authorization: `Bearer ${token}`,
        };

        const response = await fetch(
          `${API_ENDPOINT}route2.0/view-real-product/${userId}`,
          { method: "GET", headers }
        );

        const result = await response.json();

        if (response.ok) {
          const sortedData = result.data?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setProducts(sortedData);
          setOriginalData(sortedData);
          setSearchData(sortedData);
        } else {
          showSnackbar(result.message || "Something went wrong", "error");
        }
      } catch (error) {
        showSnackbar("Internal server error", "error");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const columns = [
    {
      field: "Action",
      headerName: "Action",
      width: 60,
       minWidth: 100,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
          {userRole === "center_admin" && (
            <>
              <IconButton
                style={{ color: "#00b13f" }}
                size="small"
                aria-label="edit"
                onClick={() => handleOpenEditForm(params?.row)}
              >
                <Tooltip title="Edit">
                  <EditIcon fontSize="small" style={{ fontSize: "0.8rem" }} />
                </Tooltip>
              </IconButton>

              <IconButton
                style={{ color: "#b10000ff" }}
                size="small"
                aria-label="delete"
                onClick={() => handleDeleteOpenPopup(params?.row)}
              >
                <Tooltip title="Delete">
                  <DeleteIcon fontSize="small" style={{ fontSize: "0.8rem" }} />
                </Tooltip>
              </IconButton>
            </>
          )}
        </div>
      ),
    },
    {
      field: "product_name",
      headerName: "Product Name",
      width: 200,
      minWidth: 200,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.product_name}</div>,
    },
    {
      field: "test_category",
      headerName: "Test Category",
      width: 150,
      minWidth: 150,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
          {params?.row.test_category == 1 && <div>Mock Test</div>}
          {params?.row.test_category == 2 && <div>Module Wise Test</div>}
          {params?.row.test_category == 3 && <div>Question Wise Test</div>}
        </div>
      ),
    },
    {
      field: "test_type_id",
      headerName: "Test Type",
      width: 120,
       minWidth: 120,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row.test_type_id?.name || "",
      renderCell: (params) => <div>{params?.row.test_type_id?.name}</div>,
    },

    {
      field: "sub_test_type",
      headerName: "Sub Test Type",
      width: 120,
       minWidth: 120,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row.sub_test_type_id?.name || "",
      renderCell: (params) => <div>{params?.row.sub_test_type_id?.name}</div>,
    },
    {
      field: "question_quantity",
      headerName: "Question Quantity",
      width: 150,
       minWidth: 150,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.question_quantity}</div>,
    },

    {
      field: "country_id",
      headerName: "Country",
      width: 120,
       minWidth: 120,
      headerClassName: "header-cell",
      valueGetter: (params) => params?.row.country_id?.country_name || "",
      renderCell: (params) => <div>{params?.row.country_id?.country_name}</div>,
    },
    {
      field: "currency",
      headerName: "Currency",
      width: 120,
       minWidth: 120,
      headerClassName: "header-cell",
    },
    {
      field: "product_amount",
      headerName: "Price",
       minWidth: 150,
      headerClassName: "header-cell",
      renderCell: (params) => <div>{params?.row.product_amount}</div>,
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
       minWidth: 150,
      disableColumnMenu: true,
      headerClassName: "header-cell",
      renderCell: (params) => (
        <div>
          {params?.row.is_active == 1 && (
            <Chip
              variant="contained"
              label="Active"
              size="small"
              color="secondary"
            />
          )}
          {params?.row.is_active == 0 && (
            <Chip
              variant="contained"
              label="Inactive"
              size="small"
              color="error"
            />
          )}
        </div>
      ),
    },
  ];

  const handleDeleteOpenPopup = (rowData) => {
    setSelectedRowData(rowData);
    setIsDeleteFormOpen(true);
  };

  const handleDeleteClosePopup = () => {
    setIsDeleteFormOpen(false);
    setSelectedRowData(null);
  };

  const handleDeleteProduct = async () => {
    if (!selectedRowData) return;

    const token = getTokenOrLogout();
    if (!token) return;

    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      const requestData = {
        user_id: parseInt(userId),
        is_deleted: 1,
      };

      const response = await fetch(
        `${API_ENDPOINT}real-test-product/${selectedRowData.id}`,
        {
          method: "PUT",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        // remove deleted package from state without reload
        setProducts((prev) =>
          prev.filter((product) => product.id !== selectedRowData.id)
        );
        setSearchData((prev) =>
          prev.filter((product) => product.id !== selectedRowData.id)
        );
        setOriginalData((prev) =>
          prev.filter((product) => product.id !== selectedRowData.id)
        );

        showSnackbar("Package deleted successfully", "success");
        handleDeleteClosePopup();
      } else {
        showSnackbar(result.message || "Failed to delete package", "error");
      }
    } catch (error) {
      showSnackbar("Internal server error", "error");
    }
  };

  // serach all column
  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = searchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data.product_name}`,

        `${data.test_type_id?.name || ""}`,
        `${data.sub_test_type_id?.name || ""}`,
        `${data?.country_id?.country_name || ""}`,
        `${data?.currency || ""}`,
        `${data?.product_amount || ""}`,
        `${data?.question_quantity || ""}`,
        `${
          data?.test_category === 1
            ? "Mock Test"
            : data?.test_category === 2
            ? "Module Wise Test"
            : "Question Wise Test" || ""
        }`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });

    setProducts(filteredData1); // Update the filtered data
  };

  // edit form open
  const handleOpenEditForm = (rowData) => {
    setOpenEditForm(true);
    setSelectedRowData(rowData);
  };

  const handleCloseEditForm = () => {
    setOpenEditForm(false);
  };
  return (
    <>
      <LoaderComp isLoading={isLoading} />
      <Grid container spacing={2} mb={2}>
        {/* Heading */}
        <Grid item xs={6} sm={4} md={3} lg={2}>
          <HeadingCard label="Real Test Products" />
        </Grid>

        {/* Right Side Buttons */}
        <Grid
          item
          xs={6}
          sm={8}
          md={9}
          lg={10}
          display="flex"
          justifyContent="right"
          gap={1}
        >
          {(userRole === "center_admin" || userRole === "developer") && (
            <AddButton
              onClick={() => handleOpenForm()}
              label="Add Real Test Product"
            />
          )}
        </Grid>

        {/* Main Table */}
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              {/* Search Field */}
              <Grid item xs={12} textAlign="end">
                <SearchTextFieldComp onChange={handleSearch} />
              </Grid>

              {/* Data Grid */}
              <Grid item xs={12}>
                <DataGrid
                  rows={products}
                  columns={columns}
                  slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                  autoHeight
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 25 },
                    },
                  }}
                  pageSizeOptions={[25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomPopup
        open={isAddFormOpen}
        onClose={handleCloseForm}
        component={<AddRealTestProduct onClose={handleCloseForm} />}
        title="Add Real Test Product"
        showDivider={true}
        maxWidth="sm"
      />

      <ConfirmationPopup
        open={isDeleteFormOpen}
        onClose={handleDeleteClosePopup}
        title="Delete Product Confirmation"
        textBody={`Are you sure you want to delete the Product?`}
        maxWidth="xs"
        showDivider={true}
        handleUpdateStatus={handleDeleteProduct}
      />

      <CustomPopup
        open={openEditForm}
        onClose={handleCloseEditForm}
        component={<EditRealTestProduct onClose={handleCloseEditForm} selectedRowData={selectedRowData} setSelectedRowData={setSelectedRowData}/>}
        title="Edit Real Test Product"
        showDivider={true}
        maxWidth="sm"
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}

export default RealTestProduct;
